import { render, staticRenderFns } from "./addBidPrice.vue?vue&type=template&id=0f51d6a7&scoped=true&"
import script from "./addBidPrice.vue?vue&type=script&lang=js&"
export * from "./addBidPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51d6a7",
  null
  
)

export default component.exports